import { createReferenceResolutionContextV3, type CanvasDocumentV3, type ResolvedTargetPrompt } from "@seedance/contracts";

/** Render-local, immutable-document scope. This contains no authorization decisions. */
export interface EditorReferenceSnapshot {
  readonly document: CanvasDocumentV3;
  resolve(targetNodeId: string): ResolvedTargetPrompt;
}

export function referenceSnapshotForDocument(document: CanvasDocumentV3, snapshot?: EditorReferenceSnapshot): EditorReferenceSnapshot {
  // Never use ranks/diagnostics belonging to an earlier document or another canvas.
  if (snapshot?.document === document) return snapshot;
  return Object.freeze({ document, ...createReferenceResolutionContextV3(document) });
}
